import { theme } from "@lvt/material";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import { makeStyles, withStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modaldiv: {
        display: "flex",
    },
    timeline: {
        position: "absolute",
        width: "calc(100% - 1em)",
        height: 104,
        overflowX: "hidden",
        right: "0",
        userSelect: "none",
    },
    thumbnailLine: {
        borderBottom: `4px solid ${theme.palette.grey[500]}`,
        position: "absolute",
        top: "50%",
    },
    thumbnailImage: {
        position: "absolute",
        height: "100%",
        overflow: "hidden",
        cursor: "pointer",
        zIndex: 1,
        borderLeft: "4px solid white",
        "&:hover": {
            transform: "scale(1.1, 1)",
        },
    },
    image: {
        height: "100%",
    },
    name: {
        fontSize: 16,
        color: theme.palette.grey[700],
    },
}));

export const Accordion = withStyles({
    root: {
        borderRadius: "0 0 4px 4px",
        borderColor: theme.palette.grey[300],
        borderTop: "1px solid",
        boxShadow: "none",
        margin: 0,
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: 0,
        },
    },
    expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
    root: {
        display: "flex",
        alignItems: "start",
        minHeight: 32,
        padding: "0.5em 0.5em 0.5em 0",
        width: "100%",
        "&$expanded": {
            width: "18em",
            height: 118,
            minHeight: 32,
        },
    },
    content: {
        margin: 0,
        "&$expanded": {
            margin: 0,
        },
    },
    expanded: {},
    expandIcon: {
        order: -1,
        padding: 0,
        margin: "0 0.5em",
    },
})(MuiAccordionSummary);

export const AccordionDetails = withStyles({
    root: {
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        padding: "0.5em 0",
        marginLeft: "18em",
        marginTop: -118,
    },
})(MuiAccordionDetails);
